import React, {useState, useRef, useEffect} from "react";
import CaseDuplicate, {CaseDuplicateProps} from "./CaseDuplicate.tsx";
import {getCaseFormCaseHeader} from "requests/homeowner/caseforms";
import {MSpinner} from "components/Shared";
import {getCustomerList} from "requests/customer";
import {CustomerDto, Header} from "interfaces/Mueller.Business.Models.ts";

interface CaseDuplicateFromRouteProps extends CaseDuplicateProps {
  match: { params: { controlNumber: number } }
  ,history: object
}

const CaseDuplicateFromRoute = (props: CaseDuplicateFromRouteProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [caseHeader, setCaseHeader] = useState<Header>(null);
  const [fetchingAccountList, setFetchingAccountList] = useState<boolean>(true);
  const [accountList, setAccountList] = useState<CustomerDto[]>(null);
  const mounted = useRef(true);
  const controlNumber = props.match.params.controlNumber;

  useEffect(() => {
    getCaseFormCaseHeader(controlNumber, setCaseHeader, mounted);
    getCustomerList(setAccountList, mounted);

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    setIsLoading(!caseHeader);
  }, [caseHeader]);

  useEffect(() => {
    setFetchingAccountList(!accountList);
  }, [accountList]);

  if (isLoading || fetchingAccountList) return <MSpinner />;

  const caseDuplicateProps = {
    ...props,
    controlNumber: controlNumber,
    currentAccount: caseHeader.policyInfo.customerInfo,
    surveyAddress: caseHeader.policyInfo.surveyAddress,
    currentInspectionType: caseHeader.caseInfo.currentInspectionType,
    originalInspectionType: caseHeader.caseInfo.originalInspectionType,
    specialAttentionNotes: caseHeader.caseInfo.webNotes,
    fetchingAccountList: fetchingAccountList,
    accountList: accountList,
    onFinished: () => props.history.goBack() // navigate back one step
  } as CaseDuplicateProps;
  return <CaseDuplicate {...caseDuplicateProps} />;

}

export default CaseDuplicateFromRoute;
